import React, { Fragment, useContext, useEffect, useState } from 'react';
import { ActionButton, BaseButton, Button, Checkbox, DefaultButton, Dialog, DialogFooter, DialogType, DocumentCard, DocumentCardActions, DocumentCardActivity, DocumentCardLocation, DocumentCardPreview, DocumentCardTitle, Dropdown, IDropdownOption, Icon, PersonaInitialsColor, PrimaryButton, Text, TextField, Toggle, TooltipHost } from "office-ui-fabric-react";
import { ulid } from 'ulid';
import moment from 'moment-timezone';



import { WsAppContext } from "../../AppContext";

import { Redirect, Route, Switch, useHistory, useLocation, useParams } from "react-router-dom";
import { Loading } from "../../Shared";
import { WsConfigTenant, WsTenantStatus } from "./ConfigTenant";



import { apiGet, apiPost } from "../../../helpers-sales";
import { WsConfigNormalization } from "./ConfigNormalization";

import { WsDeliverJobInterface, WsDeliverTenantInterface } from "../../../../../core/src/interfaces";

import { getTenantStatus, getWorkloads } from "../data/deliver-data";
import { WsDeliverTenantStatus } from "../../../enums";

import { WsResourcePage } from "./ResourcePage";

import { WsDeliverPortalContext } from "../DeliverPortalContext";
import { WsJobsPage } from "./JobsPage";

import { WsDeliverTenantAction, WsTenantActionButton } from "./TenantActionButton";




import './ConfigPage.scss';
import { wait } from "../../../helpers";
import { WsTenantActionDialog } from "./TenantActionDialog";




const WsDeliverDiscoveryTenant = (props: { tenant: WsDeliverTenantInterface }) => {

  const [ isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <>
      <tr key={`ws-workload-tenant`}>
          <td style={{ position: 'relative', paddingLeft: '32px' }}>
            {
              isExpanded
              ?
              <Icon iconName={'CollapseContentSingle'} className="ws-deliver-config-collapsed" style={{ verticalAlign: 'top' }} onClick={() => {
                setIsExpanded(false);
              }} />
              :
              <Icon iconName={'ExploreContentSingle'} className="ws-deliver-config-expanded" style={{ verticalAlign: 'top' }} onClick={() => {
                setIsExpanded(true);
              }} />
            } <b>{props.tenant.name}</b>
          </td>
          <td className={ 'ws-workload-yellow' }>In Progress</td>
          <td className={ 'ws-workload-yellow' }>In Progress</td>
        </tr>
        {/* {
          isExpanded
          &&
          <tr key={`ws-workload-123`}>
            <td><Loading /></td>
            <td className={ 'ws-workload-yellow' }></td>
            <td className={ 'ws-workload-yellow' }></td>
          </tr>
        } */}
        {
          isExpanded
          &&
          <>
            {
              getWorkloads().map((workloadItem, workloadIndex: number) => {
                return (
                  <tr key={`ws-workload-${workloadIndex}`}>
                    <td style={{ paddingLeft: '33px' }}>{workloadItem.name}</td>
                    <td className={ 'ws-workload-yellow' }>In Progress</td>
                    <td className={ 'ws-workload-yellow' }>In Progress</td>
                  </tr>
                );
              })
            }
          </>
        }
    </>
  );
};






export const getTimestamp = (timestamp: Date) => {

  const momentDate = moment(timestamp);

  // const textDate = momentDate.format('HH:mm:ss, DD/MM/YYYY');
  // const isoDate = momentDate.toISOString();

  const fromNow = momentDate.fromNow();

  return fromNow;
};




const WsTenant = (
  props: {
    id: string;
    name: string;
    icon: string;
    activity: string;
    title: string;
    alerts: number;
    setShow: React.Dispatch<React.SetStateAction<string>>;
    enabled: boolean;
    tenantType: string;
    setTenantActionDialogVisible: React.Dispatch<React.SetStateAction<WsDeliverTenantAction | undefined>>;
    tenants: WsDeliverTenantInterface[];
    loadData: () => Promise<void>;
  }
) => {

  const tenant = props.tenants.find((t) => t.azureTenantId === props.id);

  if (tenant) {
    return (
      <div className="ws-deliver-tenant-item">
        <DocumentCard>
          {/* <DocumentCardPreview {...previewProps} /> */}
          {/* <DocumentCardLocation
            location={props.name}
            // locationHref="/deliver/config"
            // onClick={() => {
            //   if (props.enabled) {
            //     // props.setShow('history');
            //     history.push(`/deliver/config/${props.tenantType}/${props.id}`);
            //   }
            // }}
          /> */}

          {/* <DocumentCardTitle title={props.title} /> */}

          <DocumentCardActivity
            activity={getTimestamp(tenant.modifiedAt ? tenant.modifiedAt : new Date())}
            people={[{ name: tenant.name, profileImageSrc: '', initialsColor: PersonaInitialsColor.blue }]}
          />

          <div className="ws-deliver-tenant-indicator">

            <WsTenantStatus tenant={tenant} statusField="Status" />

            {/* {
              (!tenant.fields.error && !tenant.fields.sync)
              &&
              <>
                <Icon className="ws-deliver-tenant-ok" iconName={'SkypeCircleCheck'}  />
              </>
            } */}

            {/* {
              tenant.fields.error
              &&
              <>
                <TooltipHost
                  // directionalHint={DirectionalHint.bottomCenter}
                  content={'Sync Failed!'}
                  id={`ws-deliver-tenant-sync-tooltip-${tenant.id}`}
                  className="ws-deliver-tenant-sync-tooltip"
                  calloutProps={{
                    className: 'ws-deliver-tenant-sync-tooltip-callout',
                    style: {
                      // width: '200px'
                    }
                  }}
                >
                  <Icon
                    className="ws-deliver-tenant-not-ok"
                    iconName={'Error'}
                    aria-describedby={`ws-deliver-tenant-sync-tooltip-${tenant.id}`}
                  />
                </TooltipHost>
              </>
            } */}

            {/* {
              tenant.fields.sync
              &&
              <>
                <TooltipHost
                  // directionalHint={DirectionalHint.bottomCenter}
                  content={'Syncing...'}
                  id={`ws-deliver-tenant-sync-tooltip-${tenant.id}`}
                  className="ws-deliver-tenant-sync-tooltip"
                  calloutProps={{
                    className: 'ws-deliver-tenant-sync-tooltip-callout',
                    style: {
                      // width: '200px'
                    }
                  }}
                >
                  <Icon
                    className="ws-deliver-tenant-sync"
                    iconName={'SyncStatus'}
                    aria-describedby={`ws-deliver-tenant-sync-tooltip-${tenant.id}`}
                  />
                </TooltipHost>
              </>
            } */}
          </div>

          <div className="ws-deliver-tenant-footer">

            <div className="ws-deliver-tenant-status">
              {
                tenant.fields.alerts > 0
                &&
                <>
                  <Icon className="ws-deliver-tenant-alert" iconName={'Warning'} /><div className="ws-deliver-tenant-alerts-count">{tenant.fields.alerts} Changes</div>
                </>
              }
            </div>

            <div className="ws-deliver-tenant-actions">
              <WsTenantActionButton
                setTenantActionDialogVisible={props.setTenantActionDialogVisible}
                tenantType={props.tenantType}
                tenantId={tenant.azureTenantId}
                tenant={tenant}
                loadData={props.loadData}
              />
            </div>

          </div>

          {/* <DocumentCardActions actions={[]} views={432} /> */}

        </DocumentCard>
      </div>
    );
  } else {
    return (null);
  }
};



const WsJobTab = (props: {}) => {

  const [ jobList, setJobList ] = useState<WsDeliverJobInterface[] | undefined>(undefined);

  const loadJobData = async (clearState: boolean) => {

    if (clearState) {
      setJobList(undefined);
    }

    const result = await apiGet(`/deliver/jobs`);

    if (result && Array.isArray(result.jobs)) {
      const resultData = result.jobs as WsDeliverJobInterface[];
      setJobList(resultData);
    }

    await wait(20000);

    loadJobData(false);
  };

  useEffect(() => {
    loadJobData(false);
  }, []);

  const activeJobs = jobList ? jobList.filter((item) => item.data.status !== 'COMPLETE') : [];

  if (activeJobs.length > 0) {
    return (
      <>
        <div className="ws-deliver-config-page-notification-bubble">{activeJobs.length}</div>
      </>
    );
  } else {
    return (<></>);
  }
};



const WsConfigPage = (props: {}) => {

  const appContext = useContext(WsAppContext);

  const history = useHistory();

  const [ tenants, setTenants ] = useState<WsDeliverTenantInterface[] | undefined>(undefined);

  const [ show, setShow ]= useState<string>('tenants');

  const [ newTenantDialogVisible, setNewTenantDialogVisible ] = useState<boolean>(false);

  const [ tenantActionDialogVisible, setTenantActionDialogVisible ] = useState<WsDeliverTenantAction | undefined>(undefined);

  const params: { tenantType: string, tenantId?: string, compareTenantId?: string } = useParams();



  



  // tenant data

  const loadData = async () => {

    setTenants(undefined);

    const result = await apiGet(`/deliver/tenants`);

    if (result && Array.isArray(result.deliverTenants)) {
      const resultData = result.deliverTenants as WsDeliverTenantInterface[];
      // console.log(resultData);
      setTenants(resultData);
    }
  };



  // mount

  useEffect(() => {
    loadData();
  }, []);



  if (tenants) {

    const classList = [ 'ws-deliver-page ws-deliver-config-page' ];

    if (params.tenantType === 'm365-normalization') {
      classList.push('ws-deliver-config-normalization-page');
    }

    if (params.tenantType === 'm365-status') {
      classList.push('ws-deliver-config-coverage-page');
    }

    if (params.tenantType === 'm365-coverage') {
      classList.push('ws-deliver-config-coverage-page');
    }

    

    return (
      <div className={classList.join(' ')}>

        <div className="ws-deliver-page-header">

          <div className="tabs is-medium is-boxed">
            <ul>

              <li className="ws-deliver-config-page-title">
                <h1>
                  M365
                </h1>
              </li>

              <li className={ params.tenantType === 'm365-tenants' ? 'is-active' : '' }><a onClick={() => {
                history.push('/deliver/config/m365-tenants');
              }}>Tenants</a></li>

              <li className={ params.tenantType === 'm365-jobs' ? 'is-active' : '' }><a onClick={() => {
                history.push('/deliver/config/m365-jobs');
              }}>Configuration Jobs<WsJobTab /></a></li>

              <li className={ params.tenantType === 'm365-discovery' ? 'is-active' : '' }><a onClick={() => {
                history.push('/deliver/config/m365-discovery');
              }}>Discovery</a></li>

              {/* <li className={ params.tenantType === 'm365-blueprints' ? 'is-active' : '' }><a onClick={() => {
                history.push('/deliver/config/m365-blueprints');
              }}>Blueprints</a></li> */}

              {
                process.env.NODE_ENV === 'development'
                &&
                <li className={ params.tenantType === 'm365-status' ? 'is-active' : '' }><a onClick={() => {
                  history.push('/deliver/config/m365-status');
                }}>Mapping</a></li>
              }

              <li className={ params.tenantType === 'm365-coverage' ? 'is-active' : '' }><a onClick={() => {
                history.push('/deliver/config/m365-coverage');
              }}>Coverage</a></li>

              <li className={ params.tenantType === 'm365-normalization' ? 'is-active' : '' }><a onClick={() => {
                history.push('/deliver/config/m365-normalization');
              }}>Normalization<div className="ws-deliver-config-page-notification-bubble">18</div></a></li>

              {
                appContext?.role === 'TEST'
                &&
                <>
                  <li className={ params.tenantType === 'azure' ? 'is-active' : '' }><a onClick={() => {
                    history.push('/deliver/config/azure');
                  }}>Azure</a></li>
                  <li className={ params.tenantType === 'aws' ? 'is-active' : '' }><a onClick={() => {
                    history.push('/deliver/config/aws');
                  }}>AWS</a></li>
                </>
              }

              {/* <li className={ params.tenantType === 'new' ? 'is-active' : '' }><a onClick={() => {
                history.push('/deliver/config/new');
              }}>New</a></li> */}
            </ul>
          </div>
        </div>

        {
          false
          ?
          <Loading />
          :
          <Switch>

            <Route path={`/deliver/config/m365-jobs`} component={WsJobsPage} />

            <Route path={`/deliver/config/m365-normalization/:workload?`} component={WsConfigNormalization} />

            <Route path={`/deliver/config/:tenantType/:tenantId/history`} component={WsConfigTenant} />

            <Route path={`/deliver/config/:tenantType/:tenantId/backup-history`} component={WsConfigTenant} />

            <Route path={`/deliver/config/:tenantType/:tenantId/restore/:snapshotId/:workloads`} component={WsConfigTenant} />

            <Route path={`/deliver/config/:tenantType/:tenantId/clone/:compareTenantId/:workloads`} component={WsConfigTenant} />

            <Route path={`/deliver/config/:tenantType/:tenantId/compare/:compareTenantId`} component={WsConfigTenant} />

            <Route path={`/deliver/config/:tenantType/:tenantId/current/:workload`} component={WsConfigTenant} />

            <Route path={`/deliver/config/:tenantType/:tenantId`} component={WsConfigTenant} exact />

            <Route path={`/deliver/config/:tenantType`} exact>
              {
                params.tenantType === 'm365-tenants'
                &&
                <div className="ws-deliver-tenant-list">

                  <div className="ws-deliver-config-header">
                    {/* <Text key={'ws-deliver-config-header-title'} variant={'xLarge'} nowrap block>
                      {'Tenants'}
                    </Text> */}

                    <div className="ws-deliver-config-header-options">
                      <ActionButton
                        className="ws-deliver-config-header-add-tenant"
                        iconProps={{ iconName: 'Add' }}
                        onClick={() => {
                          setNewTenantDialogVisible(true);
                        }}
                      >
                        Add Tenant
                      </ActionButton>
                    </div>
                  </div>

                  {/* <WsTenant tenants={tenants} loadData={loadData} setTenantActionDialogVisible={setTenantActionDialogVisible} id="f5d27e29-cb6c-45d1-946f-f30fb359f409" name="MSFT Sandbox (WVKJQ)"        tenantType={params.tenantType} icon="DEV" activity="Alerts: 1" title="26 Sep"  alerts={1}  setShow={setShow}  enabled={true} />
                  <WsTenant tenants={tenants} loadData={loadData} setTenantActionDialogVisible={setTenantActionDialogVisible} id="50bcdea8-e996-482b-8ca2-b75d8c9eb222" name="AVAWS Baseline (ACP201890b)" tenantType={params.tenantType} icon="DEV" activity="Alerts: 1" title="26 Sep"  alerts={1}  setShow={setShow}  enabled={true} /><br /> */}

                  <WsTenant tenants={tenants} loadData={loadData} setTenantActionDialogVisible={setTenantActionDialogVisible} id="01903a3b-cc94-744f-877a-9600e12c1c09" name="Development 1" tenantType={params.tenantType} icon="DEV"     activity="Alerts: 12"  title="26 Sep"  alerts={12} setShow={setShow}  enabled={true} />
                  <WsTenant tenants={tenants} loadData={loadData} setTenantActionDialogVisible={setTenantActionDialogVisible} id="01903a3d-3f32-7d74-875e-3bedf0fff6e4" name="Development 2" tenantType={params.tenantType} icon="DEV"     activity="No Activity" title="-"        alerts={0}  setShow={setShow}  enabled={true} />
                  <WsTenant tenants={tenants} loadData={loadData} setTenantActionDialogVisible={setTenantActionDialogVisible} id="01903a3d-5522-78c9-ae4d-4d839b679001" name="Sandbox 1"     tenantType={params.tenantType} icon="SANDBOX" activity="Alerts: 1"   title="15 April" alerts={2}  setShow={setShow}  enabled={true} />
                  <WsTenant tenants={tenants} loadData={loadData} setTenantActionDialogVisible={setTenantActionDialogVisible} id="01903a3d-6463-73da-b5ce-b0ec75891a1c" name="Sandbox 2"     tenantType={params.tenantType} icon="SANDBOX" activity="No Activity" title="-"        alerts={0}  setShow={setShow}  enabled={true} /><br />
                  <WsTenant tenants={tenants} loadData={loadData} setTenantActionDialogVisible={setTenantActionDialogVisible} id="01903a3d-73c5-7456-bd0e-f6dfe5240eb7" name="QA"            tenantType={params.tenantType} icon="QA"      activity="Alerts: 5"   title="29 May"   alerts={5}  setShow={setShow}  enabled={true} />
                  <WsTenant tenants={tenants} loadData={loadData} setTenantActionDialogVisible={setTenantActionDialogVisible} id="01903a3d-8712-70f7-a65b-74c33dc6cbe8" name="UAT"           tenantType={params.tenantType} icon="UAT"     activity="Alerts: 3"   title="3 May"    alerts={3}  setShow={setShow}  enabled={true} /><br />
                  <WsTenant tenants={tenants} loadData={loadData} setTenantActionDialogVisible={setTenantActionDialogVisible} id="01903a3d-9408-7684-8552-c2258b002acb" name="Production"    tenantType={params.tenantType} icon="PROD"    activity="Alerts: 2"   title="10 26 Sep"  alerts={2}  setShow={setShow}  enabled={true} />
                </div>
              }

              {
                params.tenantType === 'm365-discovery'
                &&
                <div className="ws-deliver-tenant-list">

                  <div className="ws-deliver-config-header">
                    <Text key={'ws-sales-clients'} variant={'xLarge'} nowrap block>
                      {'Discovery'}
                    </Text>
                  </div>

                  <table className="table is-bordered is-hoverable is-fullwidth ws-configuration-list">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Compatibility</th>
                        <th>Data</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        tenants.map((ten, tenindex) => {
                          return (
                            <Fragment key={`ws-disc-ten-${tenindex}`}>
                              <WsDeliverDiscoveryTenant tenant={ten} />
                            </Fragment>
                          );
                        })
                      }
                    </tbody>
                  </table>
                </div>
              }

              {
                params.tenantType === 'm365-blueprints'
                &&
                <div className="ws-deliver-tenant-list">

                  <div className="ws-deliver-config-header">
                    {/* <Text key={'ws-sales-clients'} variant={'xLarge'} nowrap block>
                      {'Blueprints'}
                    </Text> */}
                  </div>

                  <WsTenant tenants={tenants} loadData={loadData} setTenantActionDialogVisible={setTenantActionDialogVisible} id="0190733a-cc6e-7659-8155-c46843079259" name="Blueprint" tenantType={params.tenantType} icon="BLUEPRINT" activity="" title="24 June" alerts={0} setShow={setShow} enabled={false} />
                </div>
              }

              {
                process.env.NODE_ENV === 'development'
                &&
                <>
                </>
              }

              {
                params.tenantType === 'm365-status'
                &&
                <div className="ws-deliver-tenant-list">
                  <WsResourcePage view="POWERSHELL_STATUS" />
                </div>
              }

              {
                params.tenantType === 'm365-coverage'
                &&
                <div className="ws-deliver-tenant-list">
                  <WsResourcePage view="DSC_COVERAGE" />
                </div>
              }            

              {
                params.tenantType === 'azure-tenants'
                &&
                <div className="ws-deliver-tenant-list">

                  <div className="ws-deliver-config-header">
                    {/* <Text key={'ws-sales-clients'} variant={'xLarge'} nowrap block>
                      {'Tenants'}
                    </Text> */}
                  </div>

                  <WsTenant tenants={tenants} loadData={loadData} setTenantActionDialogVisible={setTenantActionDialogVisible} id="01903a3e-3272-7c66-92c9-c8c60b7b5feb" name="Development" tenantType={params.tenantType} icon="DEV" activity="Alerts: 4" title="7 May" alerts={4} setShow={setShow} enabled={false} />
                </div>
              }

              {
                params.tenantType === 'aws-tenants'
                &&
                <div className="ws-deliver-tenant-list">

                  <div className="ws-deliver-config-header">
                    {/* <Text key={'ws-sales-clients'} variant={'xLarge'} nowrap block>
                      {'Tenants'}
                    </Text> */}
                  </div>

                  <WsTenant tenants={tenants} loadData={loadData} setTenantActionDialogVisible={setTenantActionDialogVisible} id="01903a3e-7f0e-791f-bfd9-6b9055ba4fae" name="Sandbox" tenantType={params.tenantType} icon="SANDBOX" activity="No Activity" title="-" alerts={0} setShow={setShow} enabled={false} />
                </div>
              }

              {
                params.tenantType === 'new'
                &&
                <div style={{ textAlign: 'center' }}>
                  <br />
                  <br />
                  <br />
                  <Loading />
                </div>
              }
            </Route>

            <Redirect from="*" to="/deliver/config/m365-tenants" />
          </Switch>
        }

        {
          newTenantDialogVisible
          &&
          <WsNewTenantDialog
            hideDialog={() => {
              setNewTenantDialogVisible(false);
            }}
          />
        }

        {
          tenantActionDialogVisible
          &&
          <WsTenantActionDialog
            tenants={tenants}
            action={tenantActionDialogVisible}
            hideDialog={() => {
              setTenantActionDialogVisible(undefined);
            }}
          />
        }
      </div>
    );

  } else {
    return (
      <Loading />
    );
  }
};





const WsConfigDataType = (props: {
  page: string;
  emptyFieldsVisible: boolean;
  setEmptyFieldsVisible: React.Dispatch<React.SetStateAction<boolean>>
  dataType: string;
  setDataType: React.Dispatch<React.SetStateAction<string>>;
}) => {

  return (
    <div className="ws-deliver-config-data-type">

      {
        props.page === 'configuration'
        &&
        <>
          <div className="ws-deliver-config-header-option">
            <Toggle
              label="Empty Fields"
              inlineLabel
              onText="Included"
              offText="Hidden"
              onChange={(event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                if (checked) {
                  props.setEmptyFieldsVisible(true);
                } else {
                  props.setEmptyFieldsVisible(false);
                }
              }}
              checked={props.emptyFieldsVisible}
            />
          </div>
        </>
      }

      {
        (
          props.page === 'configuration'
          ||
          (props.page === 'normalization') // && process.env.NODE_ENV === 'development')
        )
        &&
        <>
          <div className="ws-deliver-config-header-option">
            <Toggle
              label="Resources"
              inlineLabel
              onText="Managed"
              offText="Unmanaged"
              onChange={(event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                if (checked) {
                  props.setDataType('dsc');
                } else {
                  props.setDataType('powershell');
                }
              }}
              checked={props.dataType === 'dsc'}
            />
          </div>
        </>
      }

      {/* <div className="ws-deliver-config-header-option" style={{ paddingTop: '5px' }}>
        <Checkbox
          label="Empty Fields"
          checked={false}
        />
      </div>

      <div className="ws-deliver-config-header-option" style={{ paddingTop: '5px' }}>
        <Checkbox
          label="Unmanaged Resources"
          checked={false}
        />
      </div> */}

    </div>
  );
};










type WsNewTenantDialogProps = {
  hideDialog: () => void;
};

const WsNewTenantDialog = (props: WsNewTenantDialogProps) => {

  const onDismiss = (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
    props.hideDialog();
  };

  const onClickCancel = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.hideDialog();
  };

  const onClickUpdate = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.hideDialog();
  };

  return (
    <Dialog
        className="ws-dialog-select ws-deliver-new-tenant-dialog"
        hidden={false}
        onDismiss={onDismiss}
        dialogContentProps={{
          type: DialogType.normal,
          title: `Add M365 Tenant`
        }}
        modalProps={{
          isBlocking: false,
          styles: {
            // main: { width: 300 }
          }
        }}
      >
        <Fragment>
          <div className="ws-deliver-new-tenant-form">

            <div className="columns">
              <div className="column ws-sales-country-form-left">
                <WsTenantTextField label="Tenant Name" field={'name'} />
              </div>
            </div>

            <div className="columns">
              <div className="column ws-sales-country-form-left">
                <WsTenantTextField label="Tenant ID" field={'id'} />
              </div>
            </div>

            <div className="columns">
              <div className="column ws-sales-country-form-left">
                <WsTenantTextField label="Service Principal" field={'service'} />
              </div>
            </div>

          </div>
        </Fragment>
        <DialogFooter>
          <DefaultButton onClick={onClickCancel} text="Cancel" />
          <PrimaryButton onClick={onClickUpdate} text="Connect" disabled={true} />
        </DialogFooter>
      </Dialog>
  );
};





type WsTenantTextFieldProps = {
  label?: string;
  field: string;
  // salesClient: WsSalesClient;
  // setSalesClientFields: (field: string, value: string) => Promise<void>;
};


const WsTenantTextField = ({ label, field }: WsTenantTextFieldProps) => {

  return (
    <div className="ws-sales-country-edit">

      {
        label
        &&
        <div className="ws-sales-country-edit-label">
          {label}
        </div>
      }

      <div className="ws-sales-country-edit-input">
        <TextField
          // value={getSalesClientFieldValue(salesClient, field)}
          onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
            // console.log(newValue);
            // if (newValue) {
            //   setSalesClientFields(field, newValue);
            // } else {
            //   setSalesClientFields(field, '');
            // }
          }}
        />
      </div>
    </div>
  );
};




export {
  WsConfigPage,
  WsConfigDataType
};
